export const COUNTRY = 'country'
export const STREET_NAME = 'streetName'
export const HOUSE_NUMBER = 'houseNumber'
export const STREET_AND_HOUSE_UNIFIED = 'streetNameAndHouseNumber'
export const STREET_AND_HOUSE_GROUP = 'streetNameAndHouseNumberGroup'
export const CITY = 'city'
export const STATE = 'state'
export const POSTAL_CODE = 'postalCode'
